import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Gauge, ArrowRight } from "lucide-react";

const KEY = "hvm-exit-intent-shown";

export const ExitIntent = ({ threat }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(KEY)) return;
    const onLeave = (e) => {
      if (e.clientY > 0 || e.relatedTarget) return;
      if (threat.touched || sessionStorage.getItem(KEY)) return;
      sessionStorage.setItem(KEY, "1");
      setShow(true);
    };
    const timer = setTimeout(() => document.addEventListener("mouseout", onLeave), 8000);
    return () => {
      clearTimeout(timer);
      document.removeEventListener("mouseout", onLeave);
    };
  }, [threat.touched]);

  const close = () => setShow(false);

  return (
    <AnimatePresence>
      {show && (
        <motion.aside
          data-testid="exit-intent-prompt"
          role="dialog"
          aria-label="Before you go"
          initial={{ opacity: 0, x: -24, y: 12 }}
          animate={{ opacity: 1, x: 0, y: 0 }}
          exit={{ opacity: 0, x: -24 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="hidden md:block fixed bottom-6 left-6 z-[78] w-[22rem] bg-[#131927] border border-[#26334D] clip-notch shadow-2xl shadow-black/50 tracing-beam"
        >
          <button
            data-testid="exit-intent-close"
            onClick={close}
            aria-label="Dismiss"
            className="absolute top-3 right-3 text-[#64748B] hover:text-white transition-colors"
          >
            <X size={16} />
          </button>
          <div className="p-6">
            <p className="font-tech text-[10px] tracking-[0.3em] uppercase text-[#F4A031] flex items-center gap-2">
              <Gauge size={13} /> Before you go
            </p>
            <p className="font-grotesk font-bold text-lg text-white mt-2 leading-snug">
              Ten seconds to know your rating class.
            </p>
            <p className="text-sm text-[#94A3B8] mt-2 leading-relaxed">
              Drag two sliders — vehicle mass and approach speed — and the calculator tells you whether
              your site is an M30, M50 or engineered-solution problem.
            </p>
            <a
              href="#top"
              data-testid="exit-intent-calculator"
              onClick={close}
              className="mt-4 inline-flex items-center gap-2 bg-[#F4A031] hover:bg-[#D98A1F] text-[#0B0F17] font-grotesk font-bold text-sm px-5 py-3 clip-notch-sm transition-colors"
            >
              Try the threat calculator <ArrowRight size={15} />
            </a>
          </div>
        </motion.aside>
      )}
    </AnimatePresence>
  );
};
